export default {
  Image: 'image',
  Sticker: 'sticker',
  Video: 'video',
  Logo: 'logo',
  Icon: 'icon',
  QRCode: 'qrcode'
};
